import { lazy } from 'react';

// project imports
// import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AdminLayout from 'layout/AdminLayout';
import Mapping_tm_mds from 'views/utilities/Mapping_tm_mds';
import Mapping_tm_sh from 'views/utilities/Mapping_tm_sh';
import Mapping_sh_rm from 'views/utilities/Mapping_sh_rm';
import AddVendor from 'views/utilities/AddVendor';
import ApprovalDsLayout from 'views/utilities/ApprovalLayout_Ds';
import LimitManagement from 'views/utilities/LimitManagement';
import SbiKiosk from 'views/utilities/SbiKiosk';
import PaymentStatus from 'views/utilities/PaymentStatus';
import CspCodeActivation from 'views/utilities/Services/CspCodeActivation';
import ActivationDetails from 'views/utilities/Services/CspCodeActivation/Details';
import TerminalMapping from 'views/utilities/Services/TerminalMapping';
import MappingDetails from 'views/utilities/Services/TerminalMapping/Details';
import PaymentRequest from 'views/utilities/PaymentRequest';
import VideoKyc from 'views/utilities/VideoKyc';
import KycUpload from 'views/utilities/kyc_upload';
import ProtectedRoute from 'views/pages/authentication/ProtrctedRoute/ProtectedRoute';
import Wallet from 'views/utilities/Wallet';
import WalletPayMethod from 'views/utilities/Components/wallet/WalletPayMethod';
import BankDepositTab from 'views/utilities/Components/wallet/BankDepositTab';
import TopupDSRequest from 'views/utilities/TopupRequestDs';
import { Navigate } from "react-router-dom";
import CspMappingRequest from 'views/utilities/CspMappingRequest';
import HardwareRequest from 'views/utilities/HardwareRequest';
import BankDepositRequest from 'views/utilities/BankDepositRequest';
import RmMappingLayout from 'views/utilities/RmMappingLayout';
import LocationMapping from 'views/utilities/Components/LocationMapping/LocationMapping';
import ComissionRatna from 'views/utilities/Components/Department/CommissionRatna';
import AuditTrasaction from 'views/utilities/Components/Department/Audit_compliance/AuditTrasaction';
import AuditActivity from 'views/utilities/Components/Department/Audit_compliance/AuditActivity';
import FinanceRatna from 'views/utilities/Components/Department/Finance_accounts/Ratna';
import FinanceHardware from 'views/utilities/Components/Department/Finance_accounts/FinanceHardware';
import HrCodeActivation from 'views/utilities/Components/Department/Hr_admin/HrCodeActivation';
import MarketingNetwork from 'views/utilities/Components/Department/Marketing/MarketingNetwork';
import MarketingRatna from 'views/utilities/Components/Department/Marketing/MarketingRatna';
import MarketingCodeActivation from 'views/utilities/Components/Department/Marketing/MarketingCodeActivation';
import MarketingMandate from 'views/utilities/Components/Department/Marketing/MarketingMandate';
import OpsTransaction from 'views/utilities/Components/Department/Operation/OpsTransaction';
import OpsCodeActivation from 'views/utilities/Components/Department/Operation/OpsCodeActivation';
import OpsMandate from 'views/utilities/Components/Department/Operation/OpsMandate';
import CspNetwork from 'views/utilities/Components/Department/Sales/CspNetwork';
import CodeActivation from 'views/utilities/Components/Department/Sales/CodeActivation';
import Mandate from 'views/utilities/Components/Department/Sales/Mandate';
import CspActivity from 'views/utilities/Components/Department/Sales/CspActivity';






import TransactionReport from 'views/utilities/Components/Department/Sales/TransactionReport';
import Ratna from 'views/utilities/Components/Department/CommissionRatna';
import LimitTopupChecker from 'views/utilities/LimitTopupChecker';
import VendorList from 'views/utilities/VendorList';
import VendorInvoiceDetails from 'views/utilities/Components/VendorList/InvoiceDetails';
import VendorOnboardingStatus from 'views/utilities/VendorOnboardingRequest';
import PurchaseRequest from 'views/utilities/PurchaseRequest';
import PurchaseOrder from 'views/utilities/Components/Procurement/PurchaseOrder';
import ProcurementHeadPOPendingPage from 'views/utilities/Components/Procurement/PurchaseOrder/ProcurementHeadPOpendingPage';
import PaymentOrderTable from 'views/utilities/Components/Procurement/PaymentOrder/PaymentOrderTable';
import PaymentCompletionTable from 'views/utilities/Components/Procurement/PaymentOrder/CompletePayment';
import AgreementDashboard from 'views/utilities/Components/Agreement';
import UserList from 'views/utilities/Components/UserList';
import CspStatus from 'views/utilities/Components/Csp Status';

import DSUserList from 'views/utilities/Components/UserList/DSlist';
import DsPaymentLink from 'views/utilities/DsPaymentLink';
import AecList from 'views/utilities/AecList';
import UtilsMandate from 'views/utilities/Components/Mandate';
import UtilsSurrender from 'views/utilities/Components/Mandate/Surrender';
import UtilsHrDepartment from 'views/utilities/Components/HrDepartment';
import UtilsAddDepartment from 'views/utilities/Components/HrDepartment/AddDepartment';
import LogMonitering from 'views/utilities/LogMonitering';
import BrandingRequest from 'views/utilities/Components/Procurement/BrandRequest';
import UploadBranding from 'views/utilities/Components/Procurement/BrandRequest/UploadBranding';
import BrandingDashboard from 'views/utilities/Components/Procurement/BrandDashboard';
import StockDashboard from 'views/utilities/Components/Procurement/StockDashboard';
// import { FosOnboard } from 'API/FOS';
import FosMapping from 'views/utilities/FosMapping';
import FosList from 'views/utilities/fos_list';
import DeleteUser from 'views/utilities/DeleteUser';
import AddUserRole from 'views/utilities/AddUserRole';
import EmailContent from 'views/utilities/EmailService';

// import ForgetPassword from 'views/pages/authentication/authentication3/ForgetPassword';
// import AddDevice from 'views/utilities/AddDevice';
// import ViewProducts from 'views/utilities/ViewProducts';
// import Mapping_ds_mds from 'views/utilities/Mapping_ds_mds';
// import Mapping_ds_tm from 'views/utilities/Mapping_ds_tm';
// import Mapping from 'views/utilities/Mapping';
// import ViewAllAccess from 'views/utilities/ViewAllAccess';
// import CreateGroup from 'views/utilities/CreateGroup';
// import AccessManagement from 'views/utilities/AccessManagement';
//  import MoneyTransfer from 'views/utilities/MoneyTransfer';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/AdminDashboard/Default')));

// utilities routing
const UtilsAccessManagement = Loadable(lazy(() => import('views/utilities/AccessManagement')));
const UtilsCreateGroup = Loadable(lazy(() => import('views/utilities/CreateGroup')));
// const ViewGroup = Loadable(lazy(() => import('views/utilities/Components/ViewGroup')));
const AgOnboardTM = Loadable(lazy(() => import('views/utilities/Components/AgentOnboardViaTM')));
const AgentKiosk = Loadable(lazy(() => import('views/utilities/Components/AgentOnboardViaTM/Kiosk')));
const UtilsAddDataPoints = Loadable(lazy(() => import('views/utilities/DataPoints')));
const ViewDatapoints = Loadable(lazy(() => import('views/utilities/ViewAddPoints')));
const UtilsProductMaster = Loadable(lazy(() => import('views/utilities/ProductMaster')));
const UtilsViewAccess = Loadable(lazy(() => import('views/utilities/ViewAllAccess')));
const UtilsAddProduct = Loadable(lazy(() => import('views/utilities/AddProduct')));
const UtilsApproval = Loadable(lazy(() => import('views/utilities/ApprovalLayout')));
const UtilsLeegalityApproval = Loadable(lazy(() => import('views/utilities/Components/Leegality')));
const UtilsAgentOnboarding = Loadable(lazy(() => import('views/utilities/AgentOnboarding')));
const UtilsDsOnboarding = Loadable(lazy(() => import('views/utilities/Dsonboarding')));
const UtilsFosOnboarding = Loadable(lazy(() => import('views/utilities/Components/FOS')));
const UtilsFosRequest = Loadable(lazy(() => import('views/utilities/Components/Approval FOS/SideMenu')));
const UtilsCategory = Loadable(lazy(() => import('views/utilities/CategorySetup')));
const UtilsMapping = Loadable(lazy(() => import('views/utilities/Mapping')));
const UtilsMappingDSTM = Loadable(lazy(() => import('views/utilities/Mapping_ds_tm')));
const UtilsMappingDSmds = Loadable(lazy(() => import('views/utilities/Mapping_ds_mds')));
const UtilsViewProducts = Loadable(lazy(() => import('views/utilities/ViewProducts')));
const UtilsAddDevice = Loadable(lazy(() => import('views/utilities/Components/Procurement/DeviceModule')));
const UtilsDeviceRequest = Loadable(lazy(() => import('views/utilities/Components/Procurement/DeviceModule/DeviceRequest')));
const UtilsDeviceProductShip = Loadable(lazy(() => import('views/utilities/Components/Procurement/ProductShipment')));
const UtilsCreateDeliveryNote = Loadable(lazy(() => import('views/utilities/Components/Procurement/ProductShipment/CreateDeliveryNote')));
const UtilsDeliveryNoteStatus = Loadable(lazy(() => import('views/utilities/Components/Procurement/ProductShipment/DeliveryNoteStatus')));


const UtilsInvoice = Loadable(lazy(() => import('views/utilities/Components/Procurement/Invoice')));

const UtilsProfileAgreement = Loadable(lazy(() => import('views/utilities/Components/PartnerAgreement')));
const UtilsPaymentReport = Loadable(lazy(() => import('views/utilities/Components/PaymentReport')));
const UtilsServiceStatus = Loadable(lazy(() => import('views/utilities/Components/OnboardingStatus')));
const UtilsCspReport = Loadable(lazy(() => import('views/utilities/Components/CSPReport')));
const UtilsDeboarding=Loadable(lazy(() => import('views/utilities/Components/DeboardingRequest')));
const UtilsDeboardingFrom=Loadable(lazy(() => import('views/utilities/Components/DeboardingRequest/DeboardingForm')));
const UtilsPaymentCollection = Loadable(lazy(() => import('views/utilities/Components/PaymentCollection')));
const UtilsDeboardingList=Loadable(lazy(() => import('views/utilities/Components/DeboardingList')));



const UtilsReconFi=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconFI')));
const UtilsReconNonFi=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconNonFi')));
const UtilsReconReport=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconReport')));
const UtilsReconFiReport=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconFiReport')));
const UtilsFiReconReport=Loadable(lazy(() => import('views/utilities/Components/Recon/FiReconReport')));
const UtilsNonReconReport=Loadable(lazy(() => import('views/utilities/Components/Recon/NonFiReconReport')));
const UtilsNonReconSummary=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconSummary')));
const UtilsReconFiSummary=Loadable(lazy(() => import('views/utilities/Components/Recon/ReconFiSummary')));
const UtilsFinalSummaryTable=Loadable(lazy(() => import('views/utilities/Components/Recon/FinalSummaryTable')));





const UtilsTabActivationReport=Loadable(lazy(() => import('views/utilities/Components/HardwareAllocation/TabActivation')));

const UtilsPassbookprinter=Loadable(lazy(() => import('views/utilities/Components/HardwareAllocation/PassbookPrinter')));
const UtilsMATMActivation=Loadable(lazy(() => import('views/utilities/Components/HardwareAllocation/ActivationReport')));

const UtilsDepartmentAnalytics=Loadable(lazy(() => import('views/utilities/Components/Department/Analytics')));
const UtilsDepartmentAudit_compliance=Loadable(lazy(() => import('views/utilities/Components/Department/Audit_compliance')));
const UtilsDepartmentCorporate=Loadable(lazy(() => import('views/utilities/Components/Department/Corporate')));
const UtilsDepartmentFinance_accounts=Loadable(lazy(() => import('views/utilities/Components/Department/Finance_accounts')));
const UtilsDepartmentHr_admin=Loadable(lazy(() => import('views/utilities/Components/Department/Hr_admin')));
const UtilsDepartmentIT=Loadable(lazy(() => import('views/utilities/Components/Department/IT')));
const UtilsDepartmentMarketing=Loadable(lazy(() => import('views/utilities/Components/Department/Marketing')));
const UtilsDepartmentOperation=Loadable(lazy(() => import('views/utilities/Components/Department/Operation')));
const UtilsDepartmentRenvenue_assurance=Loadable(lazy(() => import('views/utilities/Components/Department/Renvenue_assurance')));
const UtilsDepartmentSales=Loadable(lazy(() => import('views/utilities/Components/Department/Sales')));

const UtilsNonFIActivity=Loadable(lazy(() => import('views/utilities/Components/Department/Sales/Non_FI_Activity')));
const UtilsNonFITransaction=Loadable(lazy(() => import('views/utilities/Components/Department/Sales/Non_FI_Transaction')));



// sample page routing

// ==============================|| MAIN ROUTING ||============================== //

//  const userToken=sessionStorage.getItem('UserToken')

const AdminRoute = {
  path: '/',
  element: <ProtectedRoute element={<AdminLayout />}/> ,
  children: [
    {
      path: 'dashboard',
      element:<Navigate to="/dashboard/default"/>
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'Admin',
      element:<Navigate to="/dashboard/default"/>
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'AddDP',
          element: <UtilsAddDataPoints />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ProductMaster',
          element: <UtilsProductMaster />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'wallet',
          element: <Wallet/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'AddProduct',
          element: <UtilsAddProduct />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'AccessManagement',
          element: <UtilsAccessManagement />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'CreateGroup',
          element: <UtilsCreateGroup />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'AgOnboardTM',
          element: <AgOnboardTM />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'AgentKiosk',
          element: <AgentKiosk />,
          breadcrumbs: true
        },
        {
          path: '*',
          element:<Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },  
    {
      path: 'Admin',
      children: [
        {
          path: 'ViewDatapoints',
          element: <ViewDatapoints />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ViewAllAccess',
          element: <UtilsViewAccess />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'agentonboarding',
          element: <UtilsAgentOnboarding />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'dsonboarding',
          element: <UtilsDsOnboarding />,
          breadcrumbs: true
        },
        {
          path: '*',
          element:<Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'fosonboarding',
          element: <UtilsFosOnboarding />,
          breadcrumbs: true
        },
        {
          path: '*',
          element:<Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'fosrequest',
          element: <UtilsFosRequest />,
          breadcrumbs: true
        },
        {
          path: '*',
          element:<Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Requests',
          element: <UtilsApproval />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'approvals',
          element: <UtilsLeegalityApproval />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'deboarding',
          element: <UtilsDeboarding />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'deboarding_list',
          element: <UtilsDeboardingList />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },


{
      path: 'Admin',
      children: [
        {
          path: 'csp_status',
          element: <CspStatus />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },







    {
      path: 'Admin',
      children: [
        {
          path: 'deboardingform',
          element: <UtilsDeboardingFrom />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Categorysetup',
          element: <UtilsCategory />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'mapping',
          element: <UtilsMapping />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/mapping/ds_tm',
          element: <UtilsMappingDSTM />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/mapping/ds_mds',
          element: <UtilsMappingDSmds />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/mapping/tm_mds',
          element: <Mapping_tm_mds />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/mapping/tm_sh',
          element: <Mapping_tm_sh />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/mapping/sh_rm',
          element: <Mapping_sh_rm />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ViewProducts',
          element: <UtilsViewProducts />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Add_Device',
          element: <UtilsAddDevice />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Device_Request',
          element: <UtilsDeviceRequest />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Product_Ship',
          element: <UtilsDeviceProductShip />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Create_Delivery_Note',
          element: <UtilsCreateDeliveryNote />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Delivery_Note_Status',
          element: <UtilsDeliveryNoteStatus />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'Invoice',
          element: <UtilsInvoice />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Add_vendor',
          element: <AddVendor />,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ops/DsApproval',
          element: <ApprovalDsLayout />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    // limit routes
    {
      path: 'Admin',
      children: [
        {
          path: 'limit/requests',
          element: <LimitManagement />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'limit/sbi_kiosk',
          element: <SbiKiosk />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'limit/topup_checker',
          element: <LimitTopupChecker />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'payment_status',
          element: <PaymentStatus />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'payment_request',
          element: <PaymentRequest />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Csp_Code_Activation',
          element: <CspCodeActivation />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Code_Activation_Details',
          element: <ActivationDetails />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Terminal_mapping',
          element: <TerminalMapping />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Terminal_mapping_details',
          element: <MappingDetails />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'VideoKyc',
          element: <VideoKyc />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'kycupload',
          element: <KycUpload />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'aec_list',
          element: <AecList />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'ds',
      children: [
        {
          path: 'payment',
          element: <WalletPayMethod/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'bankdeposit',
          element: <BankDepositTab/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ds_wallet_topup_request',
          element: <TopupDSRequest/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Partner_Agreement',
          element: <UtilsProfileAgreement/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Payment_report',
          element: <UtilsPaymentReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Csp_report',
          element: <UtilsCspReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Service_status',
          element: <UtilsServiceStatus/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Payment_collection',
          element: <UtilsPaymentCollection/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_Fi',
          element: <UtilsReconFi/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_NonFi',
          element: <UtilsReconNonFi/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_Report',
          element: <UtilsReconReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },


    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_Fi_Report',
          element: <UtilsReconFiReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },




    {
      path: 'Admin',
      children: [
        {
          path: 'Fi_Recon_Report',
          element: <UtilsFiReconReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'NonFi_Recon_Report',
          element: <UtilsNonReconReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_Summary',
          element: <UtilsNonReconSummary/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Recon_Fi_Summary',
          element: <UtilsReconFiSummary/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'final_summary_table',
          element: <UtilsFinalSummaryTable/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'csp_mapping_request',
          element: <CspMappingRequest/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'hardware_request',
          element: <HardwareRequest/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'bankdeposit_request',
          element: <BankDepositRequest/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'MATM_Activation_Report',
          element: <UtilsMATMActivation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Passbook_printer_Activation_Report',
          element: <UtilsPassbookprinter/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'Tab_Activation_Report',
          element: <UtilsTabActivationReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'location_mapping',
          element: <LocationMapping/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'rm_mapping',
          element: <RmMappingLayout/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path:'*',
      element: <Navigate to="/dashboard/default"/>
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Analytics',
          element: <UtilsDepartmentAnalytics/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    // Sales
    {
      path: 'Department',
      children: [
        {
          path: 'Sales/code_activation',
          element: <CodeActivation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Sales/csp_network',
          element: <CspNetwork/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Sales/mandate',
          element: <Mandate/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Sales/csp_activity',
          element: <CspActivity/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Sales/transaction_report',
          element: <TransactionReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    // end of sales
    //all depts
    {
      path: 'Department',
      children: [
        {
          path: 'code_activation',
          element: <CodeActivation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'csp_network',
          element: <CspNetwork/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'mandate',
          element: <Mandate/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'csp_activity',
          element: <CspActivity/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'transaction_report',
          element: <TransactionReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'ratna/transaction_reports',
          element: <Ratna/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'MATM_Activation_Report',
          element: <UtilsMATMActivation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Passbook_printer_Activation_Report',
          element: <UtilsPassbookprinter/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Tab_Activation_Report',
          element: <UtilsTabActivationReport/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },


    {
      path: 'Department',
      children: [
        {
          path: 'Non_FI_Activity',
          element: <UtilsNonFIActivity />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

      ////////////////////////////////////////////////////////////
    {
      path: 'Department',
      children: [
        {
          path: 'Non_FI_Transaction',
          element: <UtilsNonFITransaction />,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
      /////////////////////////////////////////////////////////////





    //end of all depts
    {
      path: 'Department',
      children: [
        {
          path: 'Audit_compliance',
          element: <UtilsDepartmentAudit_compliance/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Corporate',
          element: <UtilsDepartmentCorporate/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Finance_accounts',
          element: <UtilsDepartmentFinance_accounts/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Hr_admin',
          element: <UtilsDepartmentHr_admin/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'IT',
          element: <UtilsDepartmentIT/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Marketing',
          element: <UtilsDepartmentMarketing/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Operation',
          element: <UtilsDepartmentOperation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Renvenue_assurance',
          element: <UtilsDepartmentRenvenue_assurance/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Department',
      children: [
        {
          path: 'Sales',
          element: <UtilsDepartmentSales/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'transaction_reports',
          element: <ComissionRatna/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'audit/transaction',
          element: <AuditTrasaction/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'audit/activity',
          element: <AuditActivity/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'finance/ratna',
          element: <FinanceRatna/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'finance/hardware',
          element: <FinanceHardware/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Hr_admin/code_activation',
          element: <HrCodeActivation/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Marketing/Network',
          element: <MarketingNetwork/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Marketing/ratna',
          element: <MarketingRatna/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Marketing/code_activation',
          element:<MarketingCodeActivation/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Marketing/mandate',
          element: <MarketingMandate/>,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Operation/transactions',
          element:<OpsTransaction/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Operation/code_activation',
          element:<OpsCodeActivation/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Department',
      children: [
        {
          path: 'Operation/mandate',
          element:<OpsMandate/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'vendor_list',
          element:<VendorList/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'invoice_details',
          element:<VendorInvoiceDetails/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'vendor_onboarding_request',
          element:<VendorOnboardingStatus/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'procurement',
      children: [
        {
          path: 'purchase_request',
          element:<PurchaseRequest/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'procurement',
      children: [
        {
          path: 'create_purchase_order',
          element:<PurchaseRequest/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'procurement',
      children: [
        {
          path: 'create_payment_order',
          element:<ProcurementHeadPOPendingPage/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'purchase_order',
          element:<PurchaseOrder/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'procurement_Head_PO_pending_Page',
          element:<ProcurementHeadPOPendingPage/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'payment_orders',
          element:<PaymentOrderTable/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'ds_payment_link',
          element:<DsPaymentLink/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'complete_payment',
          element:<PaymentCompletionTable/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'agreement',
          element:<AgreementDashboard/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'userlist',
          element:<UserList/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    }, {
      path: 'Admin',
      children: [
        {
          path: 'Dsuserlist',
          element:<DSUserList/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'mandate',
          element:<UtilsMandate/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'surrender',
          element:<UtilsSurrender/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'employee_onboard',
          element:<UtilsHrDepartment/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'add_department',
          element:<UtilsAddDepartment/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'fos_mapping',
          element:<FosMapping/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'fos_list',
          element:<FosList/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dev',
      children: [
        {
          path: 'logs',
          element:<LogMonitering/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'dev',
      children: [
        {
          path: 'delete_user',
          element:<DeleteUser/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'procurement',
      children: [
        {
          path: 'brandingrequest',
          element:<BrandingRequest/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'procurement',
      children: [
        {
          path: 'uploadbrand',
          element:<UploadBranding/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'branding',
      children: [
        {
          path: 'dashboard',
          element:<BrandingDashboard/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

     {
      path: 'stock',
      children: [
        {
          path: 'dashboard',
          element:<StockDashboard/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },

    {
      path: 'Admin',
      children: [
        {
          path: 'add_user_role',
          element:<AddUserRole/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
    {
      path: 'Admin',
      children: [
        {
          path: 'email_content',
          element:<EmailContent/> ,
          breadcrumbs: true
        },
        {
          path: '*',
          element: <Navigate to="/dashboard/default"/>,
          breadcrumbs: true
        }
      ]
    },
  ]
};

export default AdminRoute;
